import { BannerScheduleEntry, RaidScheduleEntry, TicketScheduleEntry } from "Models/ScheduleEntry";
import Sheet from "Models/Sheet";
import { useEffect, useMemo, useState } from "react";
const RAID_TYPES = ["TA","GA","JFD","GA2","GA3"];
export default function useScheduleSheet(props: {from: moment.Moment, to: moment.Moment}) {
	const [isReady, setIsReady] = useState(false);
	const [banners, setBanners] = useState<BannerScheduleEntry[]>([]);
	const [raidSched, setRaidSched] = useState<RaidScheduleEntry[]>([]);
	const [ticketSched, setTicketSched] = useState<TicketScheduleEntry[]>([]);
	function isInclude(start:moment.Moment, end:moment.Moment) {
		return start.isBetween(props.from, props.to, "day", "[]") || end.isBetween(props.from, props.to, "day", "[]")
		|| (start.isSameOrBefore(props.from, "day") && end.isSameOrAfter(props.to, "day"));
		;
	}
	const packagedData = useMemo(()=>{
		const rData = raidSched.filter(r => isInclude(r.start, r.end));
		return {
		BANNER: banners.filter(b => isInclude(b.start, b.end)),
		FRR: rData.filter(r => r.type === "FRR").map(r => {
			r.group = "FRR";
			return r;
		}),
		RAID: rData.filter(r => RAID_TYPES.includes(r.type)).map(r => {
			r.group = "Weekly";
			return r;
		}),
		OTHERS: [
			...rData.filter(r => !["FRR",...RAID_TYPES].includes(r.type)).map(r => {
				r.group = r.type;
				return r;
			}), 
			...ticketSched.filter(r => r.reference && isInclude(r.reference.start, r.reference.end) && isInclude(r.start, r.end))],
	}}, [banners, ticketSched, raidSched, props.from, props.to]);
	async function initialize() {
		const banner = new Sheet("1l-SI54lhBaEeV5c1AmVyzDqHgQyjhqLOMfz1adQ3vGw", "546306050");
		// const banner = new Sheet(GOOGLE_SPREADSHEET_ID, GOOGLE_SPREADSHEET_GID.BANNER);
		const bannerTask = banner.initialize();
		const raidSchedule = new Sheet("1l-SI54lhBaEeV5c1AmVyzDqHgQyjhqLOMfz1adQ3vGw", "0");
		const raidScheduleTask = raidSchedule.initialize();

		const rs = await raidScheduleTask;
		const raids = rs.findAndParseByCondition((r)=>r[0]!=null,new RaidScheduleEntry()).sort((a, b) => a.start.valueOf() - b.start.valueOf());
		const gaTickets = raids.filter(r => r.type.match(/GA\d*/gi)).map(r => TicketScheduleEntry.fromGA(r));
		const _banners = (await bannerTask).convert(new BannerScheduleEntry());
		setRaidSched(raids);
		setTicketSched(gaTickets);
		setBanners(BannerScheduleEntry.merge(_banners));
		setIsReady(true);
	}
	useEffect(() => {
		let ignore = false;
		if (!ignore && !isReady) {
			initialize();
		}
		return () => {
			ignore = true
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		isReady,
		...packagedData,
	};
}